module.exports = __webpack_public_path__ + "static/img/14000697.6b76a753.png";